import { useState } from "react";
import { LAYER_CONTENT } from "../content";
import type { NarrativeLayer } from "../types";

interface NarrativeSealProps {
  layer: NarrativeLayer;
}

export function NarrativeSeal({ layer }: NarrativeSealProps) {
  const [open, setOpen] = useState(false);
  const content = LAYER_CONTENT[layer];
  return (
    <span className="seal-wrap">
      <button
        type="button"
        className={`narrative-seal narrative-seal--${layer}`}
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        {content.label}
      </button>
      {open && (
        <span className="seal-note" role="note">
          <strong>{content.title}</strong>
          <span>{content.text}</span>
        </span>
      )}
    </span>
  );
}
